import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { isAutoMode } from '../options.context';
import { options } from '../options.Enum';
import styles from '../styles';

import ModeOption from './ModeOption';

function CardContent({ selected, handelOnPress }) {
  const theme = useTheme();


  return (
    <View style={styles.cardContent} testID={FrameworkTestKeys.displayOptionCardContentView}>
      {/* {isAutoMode && (
        <ModeOption
          theme={theme}
          selected={selected === options.auto}
          onPress={() => handelOnPress(options.auto)}
          colStyles={[styles.colStart]}
          text="display_options_mode_auto"
        />
      )}
      <View
        style={styles.divider(theme)}
        testID={FrameworkTestKeys.displayOptionCardContentDivider}
      /> */}

      <ModeOption
        theme={theme}
        selected={selected === options.light}
        onPress={() => handelOnPress(options.light)}
        colStyles={[!isAutoMode && styles.colStart]}
        text="display_options_mode_light"
      />
      <View
        style={styles.divider(theme)}
        testID={FrameworkTestKeys.displayOptionCardContentSecondDivider}
      />

      <ModeOption
        theme={theme}
        selected={selected === options.dark}
        onPress={() => handelOnPress(options.dark)}
        colStyles={[styles.colEnd]}
        text="display_options_mode_dark"
      />
    </View>
  );
}

CardContent.propTypes = {
  selected: PropTypes.string.isRequired,
  handelOnPress: PropTypes.func.isRequired,
};

export default CardContent;
